export const JSON_MIME = "application/json"
export const CONTENT_TYPE_HEADER = "Content-Type"
export const FETCH_ERROR = Symbol()
export const CATCHER_FALLBACK = Symbol()
